import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FORM, Badge, InfoRow } from './formStyles';

const formatPrice = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return `R$ ${value ?? '-'}`;
  return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const formatFixedDate = (iso) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

const ProductViewComponent = ({ productData }) => {
  const isPlan = productData?.type === 'plan';
  const isFixedDate = productData?.expirationType === 'fixedDate';
  const archived = productData?.archived;

  const renderValidity = () => {
    if (isFixedDate && productData?.fixedExpirationDate) {
      return (
        <InfoRow label="Fim de acesso" last>
          <Badge variant="info">Até {formatFixedDate(productData.fixedExpirationDate)}</Badge>
        </InfoRow>
      );
    }
    if (!isFixedDate && productData?.expirationDate) {
      return <InfoRow label="Validade" last>{`${productData.expirationDate} dias após a compra`}</InfoRow>;
    }
    return <InfoRow label="Validade" last>Sem expiração</InfoRow>;
  };

  return (
    <View style={styles.card}>
      <View style={styles.headerRow}>
        <Text style={styles.nameText} numberOfLines={2}>
          {productData?.name || 'Produto'}
        </Text>
        <View style={styles.badges}>
          <Badge variant={isPlan ? 'subscription' : 'product'}>{isPlan ? 'Assinatura' : 'Produto'}</Badge>
          <Badge variant={archived ? 'danger' : 'success'}>{archived ? 'Inativo' : 'Ativo'}</Badge>
        </View>
      </View>

      {!!productData?.description && (
        <Text style={styles.descriptionText} numberOfLines={3}>
          {productData.description}
        </Text>
      )}

      <View style={styles.rows}>
        <InfoRow label="Preço">{formatPrice(productData?.price)}</InfoRow>
        <InfoRow label="Parcelas">{productData?.paymentFractions ?? '-'}x</InfoRow>
        {isPlan && (
          <>
            <InfoRow label="Frequência">{`${productData?.frequency ?? '-'} mês(es)`}</InfoRow>
            <InfoRow label="Dias de teste grátis">{productData?.trialDays ?? 0}</InfoRow>
            <InfoRow label="Máx. cobranças">
              {Number(productData?.maxFrequency) > 0 ? productData?.maxFrequency : 'Ilimitado'}
            </InfoRow>
          </>
        )}
        {renderValidity()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    width: '100%',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  nameText: {
    flex: 1,
    fontSize: 18,
    fontWeight: '700',
    color: FORM.ink,
  },
  badges: { flexDirection: 'row', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' },
  descriptionText: {
    fontSize: 13,
    color: FORM.muted,
    marginTop: 6,
    lineHeight: 18,
  },
  rows: { marginTop: 12 },
});

export default ProductViewComponent;
